export interface IEndpoints {
	search: string,
}

export interface IArtItem {
	id: string,
	url: string,
	title: string,
	image: string,
	location: string,
	year: string,
	artist: string,
	description: string,
}

export interface IArt {
	total: number,
	page: number,
	query: string,
	count: number,
	items: IArtItem[],
	canLoadMore: boolean,
}

export interface IState {
	showSearch: boolean,
	art: IArt,
	translations: Object,
	endpoints: IEndpoints,
	loading: boolean,
}

const deafultState: IState = {
	showSearch: true,
	art: {
		total: 0,
		page: 1,
		query: '',
		count: 12,
		items: [],
		canLoadMore: false,
	},
	translations: {},
	endpoints: {
		search: ''
	},
	loading: false,
}

export default deafultState;
